import { resolveBudgetGroupIcon, resolveBudgetGroupStyle } from '../../utils/budgetGroupIcons';
import { cn } from '../../utils/cn';

const SIZES = {
  md: { box: 'h-[34px] w-[34px] rounded-ds-md', icon: 'h-[18px] w-[18px]' },
  sm: { box: 'h-7 w-7 rounded-ds-sm', icon: 'h-4 w-4' },
};

/**
 * Ícone do grupo do método — 34×34 no accordion (mockup), 28×28 na grelha desktop.
 */
export function BudgetGroupIcon({ icon, groupName, size = 'md', className }) {
  const Icon = resolveBudgetGroupIcon(icon);
  const style = resolveBudgetGroupStyle(groupName);
  const { box, icon: iconSize } = SIZES[size] || SIZES.md;

  return (
    <span
      className={cn('flex shrink-0 items-center justify-center', box, style.bg, style.text, className)}
      aria-hidden
    >
      <Icon className={iconSize} strokeWidth={2} />
    </span>
  );
}
